module.exports = __webpack_public_path__ + "static/media/app-call.0fc36be9.svg";